import { render, staticRenderFns } from "./ViewEntryDetail.vue?vue&type=template&id=bf087482&scoped=true"
import script from "./ViewEntryDetail.vue?vue&type=script&lang=js"
export * from "./ViewEntryDetail.vue?vue&type=script&lang=js"
import style0 from "./ViewEntryDetail.vue?vue&type=style&index=0&id=bf087482&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf087482",
  null
  
)

export default component.exports